export default __webpack_public_path__ + "static/map-8c6fe5de425bb94332a83c31a6eea4ac.jpeg";